import { isValid } from 'date-fns';
import { InputErrorType } from 'enums/form';
import { StringUtil } from 'lib/utilities/string';

export const EMPTY_SELECT_VALUE = ' ';

interface StringSlice {
  onChange: (v: string) => void;
  onOptionalChange: (v: string | undefined) => void;
}

interface BooleanSlice {
  onBooleanChange: (v: boolean) => void;
  onOptionalBooleanChange: (v: boolean | undefined) => void;
}

interface DateSlice {
  onDateChange: (v: string, vd: Date) => void;
  onOptionalDateChange: (v: string | undefined, vd: Date | undefined) => void;
}

interface NumberSlice {
  onNumericChange: (v: number) => void;
  onOptionalNumericChange: (v: number | undefined) => void;
}

interface PasswordSlice {
  onPasswordChange: (v: string) => void;
  onOptionalPasswordChange: (v: string | undefined) => void;
}

export type FormInputChangeDef = Partial<StringSlice> &
  Partial<BooleanSlice> &
  Partial<DateSlice> &
  Partial<NumberSlice> &
  Partial<PasswordSlice>;

// checks if value is invalid for other reasons (e.g. number, date)
export const extendedErrorDetection = (
  value: string,
  config: FormInputChangeDef
): InputErrorType | undefined => {
  if (
    (config.onNumericChange || config.onOptionalNumericChange) &&
    value.length > 0
  ) {
    const maybeNum = StringUtil.tryParseNumber(value);
    if (maybeNum === undefined) {
      return InputErrorType.InvalidNumber;
    }
  }

  if (config.onBooleanChange) {
    if (!['true', 'false'].includes(value)) {
      return InputErrorType.InvalidBoolean;
    }
  }

  if (config.onOptionalBooleanChange) {
    if (value !== EMPTY_SELECT_VALUE && !['true', 'false'].includes(value)) {
      return InputErrorType.InvalidBoolean;
    }
  }

  if (config.onDateChange) {
    const date = new Date(value);
    if (!isValid(date)) {
      return InputErrorType.InvalidDate;
    }
  }

  if (config.onOptionalDateChange) {
    const date = new Date(value);
    if (value && !isValid(date)) {
      return InputErrorType.InvalidDate;
    }
  }

  if (
    (config.onPasswordChange || config.onOptionalPasswordChange) &&
    value.length > 0
  ) {
    const { valid } = StringUtil.validPassword(value);
    if (!valid) {
      return InputErrorType.InvalidPassword;
    }
  }

  return undefined;
};
